export default __webpack_public_path__ + "images/siteLoginImage.a75627d1.svg";